import {
  AppBar,
  Box,
  Button,
  CardMedia,
  Grid,
  Stack,
  Typography,
  useTheme,
  Theme,
  IconButton,
  MenuItem,
  Menu,
  LinearProgress
} from "@mui/material";
import { Formik, Form, useFormikContext, FormikProps } from 'formik';
import { MFSubmitButton, MFTextField } from "../../lib/formik";
import { CustomInvestorLayout } from "../commonComponents";
import UseRadioGroup from "../../lib/formik/Radio";
import { KYC_VERIFICATION_METHOD } from "../../utils/constant";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { LOGOUT_SUCCESS, VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';
import { useDispatch, useSelector } from "react-redux";
import { logout, showError } from "../../redux-store/actions/auth";
import { getCKYCConsentOtp, getDigilockerKYC, postAadharXml } from "../../redux-store/actions/onBoarding";
import { ApplicationProps, CKYCConsentOtpRes, GetDigilockerResponseBody, PostAadharXmlResponse } from "../../redux-store/types/api-types";
import { set, values } from "lodash";
import TransactionsDocumentUpload from "../../lib/TransactionsDocumentUpload";
import * as yup from 'yup';
import { RootStateType } from "../../redux-store/reducers";
import { getApplicationDetails } from "../../redux-store/actions/application";
import { ProfileIcon } from "../customSVGs";
import MFCheckbox from "../../lib/formik/Checkbox";
import { isOnboardingTypeMinor } from "../../utils/utilityFunctions";

interface InitialData {
  name: string;
  email: string;
  mobile: string;
  kycMethod: string;
  documents: initialDocument[];
  ckycNo: string;
  isTermConditionsVerified?: boolean
}
interface initialDocument {
  documentId: string;
  // documentType: string;
}


const validationSchema = yup.object().shape({
  // name: yup.string().required('Required'),
  // email: yup.string().email('Invalid email').required('Required'),
  // mobile: yup.string().required('Mobile is Required'),
  kycMethod: yup.string().required('Required'),
  // documents: yup.array().of(yup.object().shape({
  //     documentId: yup.string().required('Required'),
  //     // documentType: yup.string().required('Required'),
  // })),
  isTermConditionsVerified: yup.boolean().nullable()
    .test('isTermConditionsVerified', 'Consent is required', function (value) {
      const { kycMethod } = this.parent;
      return `${kycMethod ?? ''}` === 'ckyc' ? !!value : true
    })
})

export default function KycDocSelection(): JSX.Element {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const formikRef = useRef<FormikProps<InitialData>>(null);
  const [isUploadAadharPopupOpen, setUploadAadharPopupOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [dataFetching, setDataFetching] = useState<boolean>(false);
  const [isCKYC, setCKYC] = useState<boolean>(false);
  const { token = '', } = useSelector((store: RootStateType) => store.auth);
  const { applicationId: id = '' } = useSelector((store: RootStateType) => store.id);
  const initialValues: InitialData = {
    name: "",
    email: "",
    mobile: "",
    kycMethod: "digilocker",
    documents: [
      {
        documentId: "",
        // documentType: "",
      },
    ],
    ckycNo: "",
    isTermConditionsVerified: false
  }

  const [formikValues, setFormikValues] = useState<InitialData>(initialValues);

  useEffect(() => {
    if (id === undefined) return;
    (async () => {
      try {
        setDataFetching(true);
        const res = await dispatch(getApplicationDetails(id as string)) as unknown as ApplicationProps;
        if (!res) {
          return;
        }
        const { applicants = [], isCkycAvailable } = res;
        const { name, email, mobile, ckycNo, onboardingType, minorName } = applicants[0];

        setCKYC(isCkycAvailable);
        setFormikValues({
          ...initialValues,
          kycMethod: isCkycAvailable ? "ckyc" : "digilocker",
          name: (isOnboardingTypeMinor(onboardingType ?? '') ? minorName : name) ?? '',
          email: email ?? '',
          mobile: mobile ?? '',
          ckycNo: ckycNo ?? '',
        })
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        setDataFetching(false);
      }
    })();
  }, [id])

  const handleSubmit = async () => {
    const { values } = formikRef?.current || {};
    console.log("values", values);
    if (values?.kycMethod === "digilocker") {
      try {
        setLoading(true);
        const res = await dispatch(getDigilockerKYC({ applicationId: id as string, token }) as unknown) as GetDigilockerResponseBody;
        if (res?.uri) {
          window?.open(res.uri, '_self')?.addEventListener('load', () => {
            setLoading(false);
          });
          window?.open(res.uri, '_self')?.addEventListener('error', () => {
            setLoading(false);
            console.error('Error loading window');
          });
        } else {
          setLoading(false);
          console.error('No URI returned from API');
        }
      } catch (e) {
        setLoading(false);
        console.error((e as Error).message);
      }
    }
    else if (values?.kycMethod === "aaadharxml") {
      if (!values?.documents?.[0]?.documentId) {
        dispatch(showError("Please upload Aadhaar XML file"));
        return;
      }
      try {
        const res = await dispatch(postAadharXml({
          applicationId: id,
          documentId: values?.documents?.[0]?.documentId,
        })) as unknown as PostAadharXmlResponse;
        if (!res) {
          dispatch(showError("Upload Failed Try Again"));
          return;
        }
        if (res?.result?.name) {
          dispatch(showError("Please complete your onboarding journey"))
          history.replace('/investor-onboarding-application/personal-details', { id: id });
          dispatch({ type: VERIFY_LOGIN_OTP_SUCCESS, body: { diyInvestorOnboardingEdit: true, diyIsKycDone: true } });
        } else {
          return;
        }

      } catch (e: any) {
        console.error(e);
      }

    }
    else if (values?.kycMethod === "ckyc") {
      try {
        setLoading(true);
        const res = await dispatch(getCKYCConsentOtp({ applicationId: id as string })) as unknown as CKYCConsentOtpRes;
        if (!res) {
          formikRef?.current?.setFieldValue('kycMethod', "digilocker");
          setCKYC(false);
          return;
        }
        history.replace('/ckyc-verification', { id: id, response: res });
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSubmitDocumentPopup = async () => {
    if (!formikRef.current) {
      return;
    }
    const { setTouched, values } = formikRef.current
    const errorsObj = await setTouched({
      documents: Array(values.documents.length).fill(true),
    }, true) ?? {}
    if (
      Object.keys(errorsObj)
        .filter(key => ['documents']
          .includes(key)).some(key => key in errorsObj)
    ) {
      return
    }
    setUploadAadharPopupOpen(false);
  }

  if (dataFetching) {
    return (
      <CustomInvestorLayout>
        <Box
          component="main"
          sx={{
            flex: 1,
            display: 'grid',
            placeItems: 'center',
            padding: '15px'
          }}
        >
          <Box
            sx={{
              bgcolor: 'grey.50',
              maxWidth: '857px',
              width: 'auto',
              height: 'auto',
              padding: '20px',
              mb: 2,
              borderRadius: '12px',
              boxShadow: '0px 4px 10px 0px #0000000D',
            }}
          >
            <Box
              sx={{
                padding: '26px',
                border: '1px solid #6C737F26',
                borderRadius: '6px'
              }}
            >
              <Typography
                component="h1"
                variant="h1"
                sx={{
                  color: 'primary.main',
                  mb: '32px',
                  textAlign: 'left',
                }}
              >
                Investor Details
              </Typography>
              <LinearProgress />
            </Box>
          </Box>
        </Box>
      </CustomInvestorLayout>
    )
  }

  return (
    <CustomInvestorLayout>
      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'grid',
          placeItems: 'center',
          padding: '15px'
        }}
      >
        <Box
          sx={{
            bgcolor: 'grey.50',
            maxWidth: '857px',
            width: 'auto',
            height: 'auto',
            padding: '20px',
            mb: 2,
            borderRadius: '12px',
            boxShadow: '0px 4px 10px 0px #0000000D',
          }}
        >
          <Box
            sx={{
              padding: '26px',
              border: '1px solid #6C737F26',
              borderRadius: '6px'
            }}
          >
            <Typography
              component="h1"
              variant="h1"
              sx={{
                color: 'primary.main',
                mb: '32px',
                textAlign: 'left',
              }}
            >
              Investor Details
            </Typography>
            <Formik
              innerRef={formikRef}
              initialValues={formikValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values }) => (
                <Form>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={4} sx={{ m: 0, pt: 0 }}>
                      <MFTextField
                        label="Full Name"
                        name="name"
                        placeholder="Enter Full Name"
                        disabled
                        sx={{ mt: 0 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={5} sx={{ m: 0, pt: 0 }}>
                      <MFTextField
                        label="Email Id"
                        name="email"
                        placeholder="Enter Email Id"
                        disabled
                        sx={{ mt: 0 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ m: 0, pt: 0 }}>
                      <MFTextField
                        label="Mobile Number"
                        name="mobile"
                        placeholder="Enter Mobile number"
                        disabled
                        sx={{ mt: 0 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <UseRadioGroup
                        formLabel="KYC Verification Method*"
                        name="kycMethod"
                        defaultValue="digilocker"
                        items={Object.keys(KYC_VERIFICATION_METHOD).filter(key => {
                          if (isCKYC) {
                            return key !== 'digilocker';
                          } else {
                            return key !== 'ckyc';
                          }
                        }).map(key => ({
                          label: KYC_VERIFICATION_METHOD[key],
                          value: key
                        }))}
                      />
                    </Grid>
                    {
                      values?.kycMethod === "aaadharxml" &&
                      <Grid item xs={12} md={12}>
                        <Typography variant="subtitle_600" sx={{ color: theme.palette.text.secondary, pb: '9px', fontWeight: 500 }}>Upload Aadhaar XML(only XML file type accepted)*</Typography>
                        <Button
                          variant="outlined"
                          sx={(theme: Theme) => ({
                            color: 'primary.500',
                            backgroundColor: 'transparent',
                            borderColor: 'primary.500',
                            borderWidth: '0.5px',
                            borderStyle: 'solid',
                            padding: "10px",
                            "&:hover, &.Mui-focusVisible": {
                              borderColor: 'primary.600',
                              backgroundColor: "background.default"
                            },
                            ...theme.typography.body_600
                          })} onClick={() => setUploadAadharPopupOpen(true)}>
                          {values?.documents?.[0]?.documentId ? "Update Aadhaar" : 'Upload Aadhaar'}
                        </Button>

                      </Grid>
                    }
                    {
                      values?.kycMethod === "ckyc" &&
                      (<>
                        {/* <Grid item xs={12} md={6}>
													<MFTextField
														label="Enter CKYC number*"
														name="ckycNo"
														placeholder="Enter CKYC number"
													/>
												</Grid> */}
                        <Grid item xs={12}>
                          <MFCheckbox
                            name={`isTermConditionsVerified`}
                            label={`I/We hereby consent to receiving information from the Central KYC Registry through SMS/Email on the above registered number/email address.`}
                            checked={values.isTermConditionsVerified ?? true}
                            sx={{ letterSpacing: '1px', paddingTop: 2 }}
                          />
                        </Grid>
                      </>)
                    }

                    {/* popups */}
                    <TransactionsDocumentUpload
                      open={isUploadAadharPopupOpen}
                      onClose={() => setUploadAadharPopupOpen(false)}
                      handleSubmit={handleSubmitDocumentPopup}
                      showAddMoreBtn={false}
                      documentTypeValue="Aadhaar XML"
                      fileUploadFormats={['text/xml']}
                      disabled={values.documents?.[0]?.documentId ? false : true}
                    />
                  </Grid>

                  <Box sx={{ width: '100%', mx: 'auto', mt: 5 }}>
                    <MFSubmitButton label="Start Digital Onboarding" loadingEnable={loading} />
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Box>
      </Box>
    </CustomInvestorLayout>
  );
}
